import React, { useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { postSpecialInstructions } from "../../../connections/postSpecialInstructions";
import { useQuery } from "@tanstack/react-query";
import { getTreatment } from "../../../connections/getTreatment";
import { getDoctor } from "../../../connections/getDoctor";
import useDebounce from "../../../utils/hooks";

const AddSpecialInstruction = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const [formState, setFormState] = useState({});
  const [treatmentInput, setTreatmentInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const navigate = useNavigate();
  const handleChange = (name, value) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // treatment options
  const debouncedInputTreatment = useDebounce(treatmentInput, 1000);

  const { data: getTreatmentData, isFetching: isLoading } = useQuery({
    queryKey: ["getTreatment", "all", debouncedInputTreatment],
    queryFn: () =>
      getTreatment(user?.token, null, 1, 100, debouncedInputTreatment),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
    enabled: !!debouncedInputTreatment,
  });

  const treatmentAllOptions = getTreatmentData?.payload?.treatments || [];

  // Format options for react-select
  const formattedOptions = treatmentAllOptions?.map((test) => ({
    value: test.id,
    label: test?.name,
  }));

  // doc options
  const { data: getDoctorData, isLoading: docLoader } = useQuery({
    queryKey: ["getDoctor", "all"],
    queryFn: () => getDoctor(user?.token, "all", null, null),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const allDoctorOptions = getDoctorData?.payload?.specialists || [];

  // Format options for react-select
  const formattedOptionsDr = allDoctorOptions
    ?.filter((el) => el?.sp_type === "doctor")
    ?.map((doctor) => ({
      value: doctor.id,
      label: `${doctor.first_name} ${doctor.last_name}`,
    }));
  const handleAddMedicineDescription = async (e) => {
    e.preventDefault();
    const payload = {
      special_instruction: formState,
    };
    if (!formState?.value) {
      toast?.error("Value must be provided");
      return;
    }
    if (!formState?.treatment_id) {
      toast?.error("Treatment must be provided");
      return;
    }
    try {
      const data = await postSpecialInstructions(user?.token, payload);
      if (data.status.status === "SUCCESS") {
        toast.success("Special Instruction Added Successfully");
        setFormState({});
        navigate("/admin/prescription/special_instructions");
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error);
    }
  };
  const handleMedicalChange = (inputValue) => {
    // e.preventDefault();
    setIsTyping(true);
    setTreatmentInput(inputValue);
  };
  return (
    <>
      <Header />
      <Sidebar activeClassName="special_instructions-dashboard" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}>Special Instruction</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      Add Special Instruction
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Add Special Instruction</h4>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Treatment
                              <span className="login-danger">*</span>
                            </label>
                            <Select
                              isLoading={isLoading}
                              options={formattedOptions}
                              value={
                                formattedOptions.find(
                                  (option) =>
                                    option.value === formState?.treatment_id
                                ) || null
                              }
                              onChange={(e) =>
                                handleChange("treatment_id", e?.value)
                              }
                              onInputChange={handleMedicalChange}
                              isValidNewOption={(inputValue) => {
                                if (isLoading || isTyping) return false;
                                if (!inputValue) return false;
                                return true;
                              }}
                              formatCreateLabel={(inputValue) =>
                                isLoading ? "" : `Create new "${inputValue}"`
                              }
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999, // Set your desired z-index here
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isSearchable
                              isClearable
                              placeholder="Choose treatment"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Value <span className="login-danger">*</span>
                            </label>
                            <input
                              value={formState?.value}
                              name="value"
                              onChange={(e) =>
                                handleChange("value", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Code
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.code}
                              name="code"
                              onChange={(e) =>
                                handleChange("code", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Doctor
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <Select
                              isLoading={docLoader}
                              options={formattedOptionsDr}
                              value={
                                formattedOptionsDr.find(
                                  (option) =>
                                    option.value === formState?.doctor_id
                                ) || null
                              }
                              onChange={(e) =>
                                handleChange("doctor_id", e?.value)
                              }
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999, // Set your desired z-index here
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isSearchable
                              isClearable
                              placeholder="Choose doctor"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleAddMedicineDescription}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(
                                  "/admin/prescription/special_instructions"
                                );
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default AddSpecialInstruction;
